import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import Frame from "../shell/Frame";
import Meta from "../shell/Meta";

const NotFound = () => (
  <Frame>
    <Meta title="Not found" />
    <div className="lost">
      <div>
        <div className="fig">~/404</div>
        <h2>This route does not exist.</h2>
        <p style={{ color: "#8a93a5", maxWidth: 480, margin: "0 auto 2rem" }}>
          The page you were looking for has either moved or was never published.
        </p>
        <Link to="/" className="btn btn--mint">
          Return to home <FiArrowRight />
        </Link>
      </div>
    </div>
  </Frame>
);

export default NotFound;
